import Immutable from 'immutable';
import reducerCreator from '../../tools/reducer-creator';
import * as types from '../../actions/references/types';
import {stateKeys} from '../../constants/references';
import referenceCodeWorkflowStatus from '../../constants/reference-code-workflow-status';

const initialState = Immutable.fromJS({
  [stateKeys.referenceLoading]: false,
  [stateKeys.candidateReference]: null,
  [stateKeys.referenceCodeWorkflowStatus]: referenceCodeWorkflowStatus.notVerified
});

export default reducerCreator(initialState, {
  [types.REFERENCE_SET_LOADING]: (state, { isLoading }) => state.set(stateKeys.referenceLoading, isLoading),
  [types.REFERENCE_SET_CODE_STATUS]: (state, { status }) => state.set(stateKeys.referenceCodeWorkflowStatus, status),
  [types.REFERENCE_SET_CANDIDATE_REFERENCE]: (state, { candidateReference }) => state.set(stateKeys.candidateReference, candidateReference),
});


// WEBPACK FOOTER //
// ./src/reducers/references/references.js